<template>
  <v-app>
      <router-view style = "background-color:rgb(242, 242, 227);"></router-view>
  </v-app>
</template>
<style>
.fondo {
  background-color: rgb(242, 242, 227) !important;
}
</style>
<script>
export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
